/*  
 * feed control example
 */

if (0<h && h<=1) devices.feedPump.setMLH(1);
if (1<h && h<=2) devices.feedPump.setMLH(20);
if (3<h && h<=4) devices.feedPump.setMLH(3);
if (5<h && h<=Infinity) devices.feedPump.setMLH(4);